import lodashOmit from 'lodash/fp/omit';

import {
  SR_API_ACTION_GET_LISTING_BY_ID,
  SR_API_ACTION_REMOVE_USER_BOOKMARK,
} from 'api/actionTypes';

import {
  DATA_TABLE_SOURCE_USER_BOOKMARKS,
} from 'common/dataTableConstants';

import { actionDataTableRemoveItem } from 'client/helpers/dataTables';

import analytics from 'client/analytics';
import { ANALYTICS_EVENT_LISTING_REMOVED_FROM_BOOKMARK } from 'client/analytics/eventList';

import {
  makeListingApplicationContext,
} from 'client/analytics/makeApplicationContext';

import { full as fullListingFieldgroup } from 'server/models/Listing/fieldgroups';

export default async function removeBookmark({ state, apiClient }, { listingId }) {

  const listing = await apiClient.post(SR_API_ACTION_GET_LISTING_BY_ID, {
    listingId: listingId,
    fieldgroup: fullListingFieldgroup,
  });

  await apiClient.postWithState({
    action: SR_API_ACTION_REMOVE_USER_BOOKMARK,
    state: state,
    payload: {
      listingId,
    },
    onSuccess() {
      analytics.track(
        ANALYTICS_EVENT_LISTING_REMOVED_FROM_BOOKMARK,
        makeListingApplicationContext(listing),
      );

      const newBookmarksByListingId = lodashOmit(listingId, state.get(['bookmarksByListingId']));

      state.apply(['newBookmarksCount'], (count) => Math.max(0, count - 1));
      state.set(['bookmarksByListingId'], newBookmarksByListingId);
    },
  });

  return actionDataTableRemoveItem({ state, apiClient }, {
    dataSource: DATA_TABLE_SOURCE_USER_BOOKMARKS,
    entityId: listingId,
  });
}
